import React from 'react';
import { ComponentTypes } from 'logi-embed/types';
import { LogiComponent } from '../LogiComponent';
/**
 * LogiDashboard component renders a Logi dashboard using the provided configuration.
 *
 * @component
 * @example
 * ```tsx
 * <LogiDashboard
 *   configuration={{dashboardId: '1234'}}
 *   getToken={getToken}
 *   logiBaseUrl="https://example.com"
 *   dashboardStyleWidth="800px"
 *   dashboardStyleHeight="600px"
 * />
 * ```
 *
 * @param {Object} props - The component props.
 * @param {Object} props.configuration - The configuration object for the Logi dashboard. Only requied field is dashboardId
 * @param {Function} props.getToken - The function to retrieve the access token for authentication.
 * @param {string} props.logiBaseUrl - The base URL of the Logi server.
 * @param {string} [props.dashboardStyleWidth] - The width of the dashboard container. Defaults to '100%'.
 * @param {string} [props.dashboardStyleHeight] - The height of the dashboard container. Defaults to '70vh'.
 */
export const LogiDashboard = ({ configuration, getToken, logiBaseUrl, dashboardStyleWidth, dashboardStyleHeight, }) => {
    return (React.createElement(LogiComponent, { componentType: ComponentTypes.DASHBOARD, configuration: configuration, getToken: getToken, logiBaseUrl: logiBaseUrl, styleWidth: dashboardStyleWidth, styleHeight: dashboardStyleHeight }));
};
